import React, {
  useState,
  useCallback,
  useContext,
} from "react";
import styled from "styled-components";
import toast from "react-hot-toast";
import Cookies from "js-cookie";
import PageLoader from "../../Common/PageLoader";
import { UserContext } from "../../../Context/user_context";
import { useScreenWidth } from "../../../helper/screentWidth";
import { States } from "../../../utils/States";
import EditPic from "../../../SVGs/Edit.svg";
import { useNavigate } from "react-router-dom";
import CustomTextField from "../../Common/CustomTextField";
import CustomDropDown from "../../Common/CustomDropDown";
import CustomRadioButton from "../../Common/CustomRadioButton";
import CustomTextArea from "../../Common/CustomTextArea";
import TrainingPrograms from "../../Common/TrainingPrograms";
import NonTrainingPrograms from "../../Common/NonTrainingPrograms";
import IncomeSource from "../../Common/IncomeSource";
import { Types } from "../../../utils/Types";

import {
  getApiClient,
} from "../../../server/get_api_client";



// ======================================================================
// ====================== MAIN COMPONENT ================================
// ======================================================================

function MemberInformation({ error, message, data, contactId, refetchData, type = "Client", createContact = false, setOpenModal }) {

  const { user, setUser } = useContext(UserContext);
  const screenWidth = useScreenWidth();
  const navigate = useNavigate();

  const handleContinueToHousehold = () => {
    navigate("/Household");
    window.scrollTo(0, 0);
  };
  const handleSaveContinueToHousehold = async () => {
    const success = await handleUpdate();
    if (success) {
      navigate("/Household");
      window.scrollTo(0, 0);

    }

  };
  const handleCancel = async () => {
    setOpenModal(false);
  };

  // =========================================================================
  // ====================== GENERAL INFORMATION ==============================
  // =========================================================================

  const [edit, setEdit] = useState(createContact);
  const [loading, setLoading] = useState(false);

  const generalOptions = [
    { key: 100000000, value: 100000000, text: "Dr" },
    { key: 100000001, value: 100000001, text: "Mr" },
    { key: 100000002, value: 100000002, text: "Ms" },
    { key: 100000003, value: 100000003, text: "Mrs" },
  ];

  const generalGenders = [
    { key: 1, value: 1, text: "Male" },
    { key: 2, value: 2, text: "Female" },
  ];

  
  const Pronouns = [
    {
      key: 1,
      value: 1,
      text: "He/Him",
    },
    {
      key: 2,
      value: 2,
      text: "She/Her",
    },
    {
      key: 3,
      value: 3,
      text: "They/Them",
    },
  ];

  const maritalStatusList = [
    { key: 910310004, value: 910310004, text: "Life Partner" },
    { key: 2, value: 2, text: "Married" },
    { key: 1, value: 1, text: "Single" },
    { key: 3, value: 3, text: "Divorced" },
    { key: 910310000, value: 910310000, text: "Remarried" },
    { key: 4, value: 4, text: "Widowed" },
    { key: 910310001, value: 910310001, text: "Engaged" },
    { key: 910310002, value: 910310002, text: "Separated" },
    { key: 910310003, value: 910310003, text: "Divorced-Newly Engaged" },
  ];

  const [title, setTitle] = useState(data?.new_title || "");
  const [preferredFirstName, setPreferredFirstName] = useState(data?.hip_preferredfirstname || "");
  const [birthday, setBirthday] = useState(data?.birthdate || "");
  const [gender, setGender] = useState(data?.gendercode || "");
  const [pronouns, setPronouns] = useState(data?.hip_pronouns || "");
  const [legalFirstName, setLegalFirstName] = useState(data?.firstname || "");
  const [legalLastName, setLegalLastName] = useState(data?.lastname || "");
  const [suffix, setSuffix] = useState(data?.suffix || "");

  const [maritalStatus, setMaritalStatus] = useState(data?.familystatuscode || "");



  // =========================================================================
  // ====================== EMPLOYMENT INFORMATION ===========================
  // =========================================================================


  const [residencyCompletion, setResidencyCompletion] = useState(
    data?.new_trainingcompletion ? data.new_trainingcompletion.split("T")[0] : ""
  );

  const [fellowshipCompletion, setFellowshipCompletion] = useState(
    data?.new_trainingcompletedf ? data.new_trainingcompletedf.split("T")[0] : ""
  );

  const [fellowship, setFellowship] = useState(
    data?._hip_fellowshipspecialtyid_value || null
  );

  const [residency, setResidency] = useState(
    data?._hip_residencyspecialtyid_value || null
  );

  const [companyGroup, setCompanyGroup] = useState(
    data?._hip_companygroup_value || null
  );

  // eslint-disable-next-line
  const [companyGroupName, setCompanyGroupName] = useState(
    data?.["_hip_companygroup_value@OData.Community.Display.V1.FormattedValue"] || ""
  );

  const [companyGroupText, setCompanyGroupText] = useState(
    data?.hip_companygrouptext || ""
  );

  const [isCustomCompanyGroup, setIsCustomCompanyGroup] = useState(
    Boolean(data?.hip_companygrouptext && !data?._hip_companygroup_value)
  );

  const [incomeSource, setIncomeSource] = useState(data?.hip_incomesource || "");
  const [netWorth, setNetWorth] = useState(data?.new_networth || "");
  const [jobTitle, setJobTitle] = useState(data?.jobtitle || "");
  const [annualIncome, setAnnualIncome] = useState(data?.annualincome || "");





  // =========================================================================
  // ====================== CITIZENSHIP SECTION =============================
  // =========================================================================


  const [isUSCitizen, setIsUSCitizen] = useState(data?.hfa_uscitizen ?? true);
  const [usStateOfBirth, setUsStateOfBirth] = useState(data?.hfa_usstateofbirth || "");
  const [citNotes, setCitNotes] = useState(data?.hfa_citizenshipnotes || "");
  const [ssn, setSsn] = useState(data?.new_socialsecurity1 || "");

  const handleSSN = (value) => {
    const digits = value.replace(/\D/g, "").slice(0, 9);
    let formatted = "";
    if (digits.length > 0) formatted = digits.slice(0, 3);
    if (digits.length > 3) formatted += "-" + digits.slice(3, 5);
    if (digits.length > 5) formatted += "-" + digits.slice(5);
    setSsn(formatted);
  };




  // =========================================================================
  // ====================== CONTACT INFORMATION =============================
  // =========================================================================


  const [email, setEmail] = useState(data?.emailaddress1 || "");
  const [mobilePhone, setMobilePhone] = useState(data?.mobilephone || "");
  const [homePhone, setHomePhone] = useState(data?.telephone2 || "");
  const [mobileTexting, setMobileTexting] = useState(true);

  const formatPhone = (value) => {
    const digits = value.replace(/\D/g, "").slice(0, 10);
    let formatted = "";

    if (digits.length > 0) formatted = digits.slice(0, 3);
    if (digits.length > 3) formatted += "-" + digits.slice(3, 6);
    if (digits.length > 6) formatted += "-" + digits.slice(6, 10);

    return formatted;
  };

  const handleHomePhone = (newValue) => {
    setHomePhone(formatPhone(newValue));
  };

  const handleMobilePhone = (newValue) => {
    setMobilePhone(formatPhone(newValue));
  };

  // =========================================================================
  // ====================== HOME ADDRESS ====================================
  // =========================================================================



  const [street1, setStreet1] = useState(data?.address1_line1 || "");
  const [street2, setStreet2] = useState(data?.address1_line2 || "");
  const [city, setCity] = useState(data?.address1_city || "");
  const [state, setState] = useState(data?.hip_address1_state || "");
  const [zip, setZip] = useState(data?.address1_postalcode || "");
  const [moveInDate, setMoveInDate] = useState(data?.new_moveindate || "");
  const [sameHomeAddress, setSameHomeAddress] = useState(
    data?.hip_samehomeaddressasmaincontact === 910310000
  );




  // =========================================================================
  // ====================== DRIVER LICENSE ==================================
  // =========================================================================

  const [dlNumber, setDlNumber] = useState(data?.new_driverslicense || "");
  const [dlState, setDlState] = useState(data?.new_driverslicensestate || "");
  const [dlIssue, setDlIssue] = useState(data?.new_dlissuedate || "");
  const [dlExpire, setDlExpire] = useState(data?.new_dlexpirationdate || "");




  // =========================================================================
  // ====================== OTHER INFORMATION ===============================
  // =========================================================================


  const [height, setHeight] = useState(data?.new_height || "");
  const [weight, setWeight] = useState(data?.new_weight || "");
  const [medications, setMedications] = useState(
    data?.new_currentmedicationsconditions || ""
  );


  // ====================================================================================
  // =============================== Send Updates to Backend ============================
  // ====================================================================================
  const getChangedFields = useCallback(() => {
    const changes = [];

    const hasChanged = (newVal, oldVal) => {
      const normalizeVal = (v) => v === null || v === undefined || v === '' ? null : v;
      return normalizeVal(newVal) !== normalizeVal(oldVal);
    };

    // General Information
    if (hasChanged(title, data?.new_title)) {
      changes.push({ fieldname: "new_title", type: "optionset", value: title });
    }
    if (hasChanged(gender, data?.gendercode)) {
      changes.push({ fieldname: "gendercode", type: "optionset", value: gender });
    }
    if (hasChanged(pronouns, data?.hip_pronouns)) {
      changes.push({ fieldname: "hip_pronouns", type: "optionset", value: pronouns });
    }
    if (hasChanged(maritalStatus, data?.familystatuscode)) {
      changes.push({ fieldname: "familystatuscode", type: "string", value: maritalStatus });
    }
    if (hasChanged(birthday, data?.birthdate)) {
      changes.push({ fieldname: "birthdate", type: "date", value: birthday });
    }
    if (hasChanged(legalLastName, data?.lastname)) {
      changes.push({ fieldname: "lastname", type: "string", value: legalLastName });
    }
    if (hasChanged(legalFirstName, data?.firstname)) {
      changes.push({ fieldname: "firstname", type: "string", value: legalFirstName });
    }
    if (hasChanged(preferredFirstName, data?.hip_preferredfirstname)) {
      changes.push({ fieldname: "hip_preferredfirstname", type: "string", value: preferredFirstName });
    }
    if (hasChanged(suffix, data?.suffix)) {
      changes.push({ fieldname: "suffix", type: "string", value: suffix });
    }

    // Employment Information
    if (hasChanged(residency, data?._hip_residencyspecialtyid_value)) {
      changes.push({ fieldname: "hip_ResidencySpecialtyId", type: "lookup", entity: "accounts", value: residency });
    }
    if (hasChanged(fellowship, data?._hip_fellowshipspecialtyid_value)) {
      changes.push({ fieldname: "hip_FellowshipSpecialtyId", type: "lookup", entity: "accounts", value: fellowship });
    }

    const oldResidencyCompletion = data?.new_trainingcompletion ? data.new_trainingcompletion.split("T")[0] : "";
    if (hasChanged(residencyCompletion, oldResidencyCompletion)) {
      changes.push({ fieldname: "new_trainingcompletion", type: "datetime", value: residencyCompletion });
    }

    const oldFellowshipCompletion = data?.new_trainingcompletedf ? data.new_trainingcompletedf.split("T")[0] : "";
    if (hasChanged(fellowshipCompletion, oldFellowshipCompletion)) {
      changes.push({ fieldname: "new_trainingcompletedf", type: "datetime", value: fellowshipCompletion });
    }

    if (hasChanged(incomeSource, data?.hip_incomesource)) {
      changes.push({ fieldname: "hip_incomesource", type: "optionset", value: incomeSource });
    }
    if (hasChanged(netWorth, data?.new_networth)) {
      changes.push({ fieldname: "new_networth", type: "int", value: netWorth });
    }
    if (hasChanged(jobTitle, data?.jobtitle)) {
      changes.push({ fieldname: "jobtitle", type: "string", value: jobTitle });
    }
    if (hasChanged(annualIncome, data?.annualincome)) {
      changes.push({ fieldname: "annualincome", type: "int", value: annualIncome });
    }

    const oldIsCustomCompanyGroup = Boolean(data?.hip_companygrouptext && !data?._hip_companygroup_value);

    if (isCustomCompanyGroup) {
      if (hasChanged(companyGroupText, data?.hip_companygrouptext) || !oldIsCustomCompanyGroup) {
        changes.push({ fieldname: "hip_companygrouptext", type: "string", value: companyGroupText });
        if (!oldIsCustomCompanyGroup) {
          changes.push({ fieldname: "hip_CompanyGroup", type: "lookup", entity: "accounts", value: null });
        }
      }
    } else {
      if (hasChanged(companyGroup, data?._hip_companygroup_value) || oldIsCustomCompanyGroup) {
        changes.push({ fieldname: "hip_CompanyGroup", type: "lookup", entity: "accounts", value: companyGroup });
        if (oldIsCustomCompanyGroup) {
          changes.push({ fieldname: "hip_companygrouptext", type: "string", value: null });
        }
      }
    }

    // Citizenship
    if (hasChanged(isUSCitizen, data?.hfa_uscitizen)) {
      changes.push({ fieldname: "hfa_uscitizen", type: "string", value: isUSCitizen });
    }
    if (hasChanged(usStateOfBirth, data?.hfa_usstateofbirth)) {
      changes.push({ fieldname: "hfa_usstateofbirth", type: "optionset", value: usStateOfBirth });
    }
    if (hasChanged(citNotes, data?.hfa_citizenshipnotes)) {
      changes.push({ fieldname: "hfa_citizenshipnotes", type: "string", value: citNotes });
    }
    if (hasChanged(ssn, data?.new_socialsecurity1)) {
      changes.push({ fieldname: "new_socialsecurity1", type: "string", value: ssn });
    }

    // Contact Information
    if (hasChanged(email, data?.emailaddress1)) {
      changes.push({ fieldname: "emailaddress1", type: "string", value: email });
    }
    if (hasChanged(mobilePhone, data?.mobilephone)) {
      changes.push({ fieldname: "mobilephone", type: "string", value: mobilePhone });
    }
    if (hasChanged(homePhone, data?.telephone2)) {
      changes.push({ fieldname: "telephone2", type: "string", value: homePhone });
    }

    // Home Address
    if (hasChanged(street1, data?.address1_line1)) {
      changes.push({ fieldname: "address1_line1", type: "string", value: street1 });
    }
    if (hasChanged(street2, data?.address1_line2)) {
      changes.push({ fieldname: "address1_line2", type: "string", value: street2 });
    }
    if (hasChanged(city, data?.address1_city)) {
      changes.push({ fieldname: "address1_city", type: "string", value: city });
    }
    if (hasChanged(state, data?.hip_address1_state)) {
      changes.push({ fieldname: "hip_address1_state", type: "string", value: state });
    }
    if (hasChanged(zip, data?.address1_postalcode)) {
      changes.push({ fieldname: "address1_postalcode", type: "string", value: zip });
    }
    if (hasChanged(moveInDate, data?.new_moveindate)) {
      changes.push({ fieldname: "new_moveindate", type: "string", value: moveInDate });
    }

    const oldSameHomeAddress = data?.hip_samehomeaddressasmaincontact === 910310000;
    if (sameHomeAddress !== oldSameHomeAddress) {
      changes.push({
        fieldname: "hip_samehomeaddressasmaincontact",
        type: "optionset",
        value: sameHomeAddress ? "910310000" : "910310001"
      });
    }

    // Driver License
    if (hasChanged(dlNumber, data?.new_driverslicense)) {
      changes.push({ fieldname: "new_driverslicense", type: "string", value: dlNumber });
    }
    if (hasChanged(dlState, data?.new_driverslicensestate)) {
      changes.push({ fieldname: "new_driverslicensestate", type: "optionset", value: dlState });
    }
    if (hasChanged(dlIssue, data?.new_dlissuedate)) {
      changes.push({ fieldname: "new_dlissuedate", type: "date", value: dlIssue });
    }
    if (hasChanged(dlExpire, data?.new_dlexpirationdate)) {
      changes.push({ fieldname: "new_dlexpirationdate", type: "date", value: dlExpire });
    }

    // Other Information
    if (hasChanged(height, data?.new_height)) {
      changes.push({ fieldname: "new_height", type: "string", value: height });
    }
    if (hasChanged(weight, data?.new_weight)) {
      changes.push({ fieldname: "new_weight", type: "string", value: weight });
    }
    if (hasChanged(medications, data?.new_currentmedicationsconditions)) {
      changes.push({ fieldname: "new_currentmedicationsconditions", type: "string", value: medications });
    }

    // Initial portal update flag
    if (!user.hip_initialportalinfoupdate) {
      changes.push({
        fieldname: "hip_initialportalinfoupdate",
        value: "910310000",
        type: "optionset"
      });
    }

    return changes;
  }, [
    title, gender, maritalStatus, birthday, legalLastName, legalFirstName, preferredFirstName,
    residency, fellowship, residencyCompletion, fellowshipCompletion, incomeSource, netWorth,
    jobTitle, annualIncome, companyGroup, companyGroupText, isCustomCompanyGroup,
    isUSCitizen, usStateOfBirth, citNotes, ssn, email, mobilePhone, homePhone,
    street1, street2, city, state, zip, moveInDate, sameHomeAddress,
    dlNumber, dlState, dlIssue, dlExpire, height, weight, medications,
    data, user, suffix, pronouns
  ]);




  const handleUpdate = async () => {
    const missingFields = [];

    if (!title) missingFields.push("Title");
    if (!birthday) missingFields.push("Birthday");
    if (!legalFirstName) missingFields.push("Legal First Name");
    if (!legalLastName) missingFields.push("Legal Last Name");
    if (!gender) missingFields.push("Gender");
    if (!mobilePhone && type !== Types.CHILD) missingFields.push("Mobile Phone");
    if (!ssn && type !== Types.CHILD) missingFields.push("SSN");
    if (!street1 && !sameHomeAddress && type !== Types.CHILD) missingFields.push("Street1");
    if (!city && !sameHomeAddress && type !== Types.CHILD) missingFields.push("City");
    if (!state && !sameHomeAddress && type !== Types.CHILD) missingFields.push("State");
    if (!zip && !sameHomeAddress && type !== Types.CHILD) missingFields.push("Zip Code");


    if (missingFields.length > 0) {
      const hasAddressFields = missingFields.some(field =>
        ["Street1", "City", "State", "Zip"].includes(field)
      );

      if (hasAddressFields && type !== "Client") {
        toast.error(`Please fill in the following required fields: ${missingFields.join(", ")}. For Address fields you can select "Same address as main contact", if the address is the same as yours`);
      } else {
        toast.error(`Please fill in the following required fields: ${missingFields.join(", ")}.`);
      }

      return false;
    }


    if (title === 100000000 && !residency && !fellowship) {
      toast.error("If Title is Dr, you must complete either Residency Program or Fellowship Program.");
      return false;
    }

    if (ssn && !/^\d{3}-\d{2}-\d{4}$/.test(ssn)) {
      toast.error("Please enter a valid SSN in the format xxx-xx-xxxx.");
      return false;
    }


    if (mobilePhone && !/^\d{3}-\d{3}-\d{4}$/.test(mobilePhone)) {
      toast.error("Please enter a valid Mobile Phone in the format xxx-xxx-xxxx.");
      return false;
    }

    if (homePhone && !/^\d{3}-\d{3}-\d{4}$/.test(homePhone)) {
      toast.error("Please enter a valid Home Phone in the format xxx-xxx-xxxx.");
      return false;
    }

    const changedFields = getChangedFields();

    if (changedFields.length === 0) {
      toast.success("No changes detected.");
      setEdit(false);
      return true;
    }

    setLoading(true);
    const userid = contactId ? contactId : Cookies.get("hippocratic_portal_contactid");

    const recordData = {
      entity: "contacts",
      id: userid,
      attributes: changedFields,
    };

    try {
      await getApiClient().updateRecord(recordData);
      toast.success(`Information updated successfully.`);

      if (!user.hip_initialportalinfoupdate) {
        setUser({ ...user, hip_initialportalinfoupdate: true });
      }

      refetchData && refetchData();
      setEdit(false);
      return true;
    } catch (err) {
      console.log(err);
      toast.error("Error updating information");
      return false;
    } finally {
      setLoading(false);

    }
  };


  // ====================================================================================
  // ========== In case of create spouse/child, Post to Backend =========================
  // ====================================================================================
  const handleCreate = async () => {
    const missingFields = [];

    if (!title) missingFields.push("Title");
    if (!birthday) missingFields.push("Birthday");
    if (!legalFirstName) missingFields.push("Legal First Name");
    if (!legalLastName) missingFields.push("Legal Last Name");
    if (!gender) missingFields.push("Gender");
    if (!mobilePhone && type !== Types.CHILD) missingFields.push("Mobile Phone");
    if (!ssn && type !== Types.CHILD) missingFields.push("SSN");
    if (!street1 && !sameHomeAddress && type !== Types.CHILD) missingFields.push("Street1");
    if (!city && !sameHomeAddress && type !== Types.CHILD) missingFields.push("City");
    if (!state && !sameHomeAddress && type !== Types.CHILD) missingFields.push("State");
    if (!zip && !sameHomeAddress && type !== Types.CHILD) missingFields.push("Zip Code");


    if (missingFields.length > 0) {
      const hasAddressFields = missingFields.some(field =>
        ["Street1", "City", "State", "Zip"].includes(field)
      );

      if (hasAddressFields && type !== "Client") {
        toast.error(`Please fill in the following required fields: ${missingFields.join(", ")}. For Address fields you can select "Same address as main contact", if the address is the same as yours`);
      } else {
        toast.error(`Please fill in the following required fields: ${missingFields.join(", ")}.`);
      }

      return false;
    }

    if (title === 100000000 && !residency && !fellowship) {
      toast.error("If Title is Dr, you must complete either Residency Program or Fellowship Program.");
      return false;
    }

    if (ssn && !/^\d{3}-\d{2}-\d{4}$/.test(ssn)) {
      toast.error("Please enter a valid SSN in the format xxx-xx-xxxx.");
      return false;
    }

    if (mobilePhone && !/^\d{3}-\d{3}-\d{4}$/.test(mobilePhone)) {
      toast.error("Please enter a valid Mobile Phone in the format xxx-xxx-xxxx.");
      return false;
    }

    if (homePhone && !/^\d{3}-\d{3}-\d{4}$/.test(homePhone)) {
      toast.error("Please enter a valid Home Phone in the format xxx-xxx-xxxx.");
      return false;
    }

    const changedFields = getChangedFields();

    if (changedFields.length === 0) {
      toast.success("No changes detected.");
      setEdit(false);
      return true;
    }

    setLoading(true);
    const userid = contactId ? contactId : Cookies.get("hippocratic_portal_contactid");

    const recordData = {
      id: userid,
      type: type === Types.SPOUSE ? 591930000 : 100000008,
      attributes: changedFields,
    };

    try {
      await getApiClient().createRecord(recordData);
      toast.success(`Created successfully.`);

      refetchData && refetchData();
      setEdit(false);
      setOpenModal(false);
      window.location.reload();

      return true;
    } catch (err) {
      console.log(err);
      toast.error("Submission Failed");
      return false;
    } finally {
      setLoading(false);

    }
  };




  // ====================================================================================
  // =============================== RETURN =============================================
  // ====================================================================================

  return (
    <>
      <PageLoader
        isLoading={loading}
      />

      <Wrapper>
        <PageInfo>
          {user && !user.hip_initialportalinfoupdate && (
            <WelcomeMessage>
              Welcome to the Hippocratic Client Portal.
              <br />
              Please complete the missing information below. This helps us move forward efficiently and provide support tailored to your needs.
            </WelcomeMessage>
          )}
          {error && <ErrorMessage>{error}</ErrorMessage>}
          {message && <Message>{message}</Message>}
          {/* ==================================================================== */}
          {/* ===================== GENERAL INFORMATION ========================= */}
          {/* ==================================================================== */}
          <Section>
            <TopRow>
              <Title>General Information</Title>
              {!createContact && <>
                {!edit ? (
                  <EditButton onClick={() => setEdit(true)}>
                    Edit Information
                    <img src={EditPic} alt="edit" style={{ height: 19 }} />
                  </EditButton>
                ) : (
                  <SaveButton onClick={handleUpdate}>
                    Save Changes
                  </SaveButton>
                )}
              </>}
            </TopRow>

            <Grid>
              <CustomDropDown
                Active={edit}
                options={generalOptions}
                Title="Title *"
                value={title}
                onChange={setTitle}
              />
              <CustomTextField
                Active={edit}
                Title="Legal First Name *"
                value={legalFirstName}
                onChange={setLegalFirstName}

              />
              <CustomTextField
                Active={edit}
                Title="Legal Last Name *"
                value={legalLastName}
                onChange={setLegalLastName}

              />
              <CustomTextField
                Active={edit}
                Title="Preferred First Name"
                value={preferredFirstName}
                onChange={setPreferredFirstName}
              />
              <CustomTextField
                Active={edit}
                Title="Suffix"
                value={suffix}
                onChange={setSuffix}
              />
              <CustomDropDown
                Active={edit}
                options={generalGenders}
                Title="Gender *"
                value={gender}
                onChange={setGender}
              />
              <CustomDropDown
                Active={edit}
                options={Pronouns}
                Title="Pronouns"
                value={pronouns}
                onChange={setPronouns}
              />
              <CustomTextField
                Active={edit}
                Title="Birthday *"
                Type="date"
                value={birthday}
                onChange={setBirthday}
              />
              {type !== Types.CHILD &&
                <>
                  <CustomDropDown
                    Active={edit}
                    options={maritalStatusList}
                    Title="Marital Status"
                    value={maritalStatus}
                    onChange={setMaritalStatus}
                  />
                </>}

            </Grid>
          </Section>





          {/* ==================================================================== */}
          {/* ===================== EMPLOYMENT INFORMATION ====================== */}
          {/* ==================================================================== */}
          {type !== Types.CHILD ?
            <>
              <Section>
                <TopRow>
                  <Title>Employment Information</Title>

                </TopRow>

                {screenWidth >= 690 ? (
                  <Grid>

                    <Column>
                      {title === 100000000 && (
                        <>
                          <TrainingPrograms
                            Active={edit}
                            value={residency}
                            Title="Residency Program"
                            type={591930000}
                            onChange={setResidency}
                          />
                          <TrainingPrograms
                            Active={edit}
                            value={fellowship}
                            Title="Fellowship Program"
                            type={591930001}
                            onChange={setFellowship}
                          />
                        </>
                      )}

                      <NonTrainingPrograms
                        Active={edit}
                        value={companyGroup}
                        valueName={companyGroupName}
                        Title="Company / Group"
                        onChange={setCompanyGroup}
                        textValue={companyGroupText}
                        onTextChange={setCompanyGroupText}
                        isCustom={isCustomCompanyGroup}
                        onCustomToggle={setIsCustomCompanyGroup}
                      />

                      {title !== 100000000 && (
                        <CustomTextField
                          Active={edit}
                          Title="Annual Income"
                          currency
                          value={annualIncome}
                          onChange={setAnnualIncome}
                        />
                      )}
                    </Column>
                    <Column>
                      {title === 100000000 && (
                        <>
                          <CustomTextField
                            Active={edit}
                            Title="Residency Completion"
                            Type="date"
                            value={residencyCompletion}
                            onChange={setResidencyCompletion}
                          />
                          <CustomTextField
                            Active={edit}
                            Title="Fellowship Completion"
                            Type="date"
                            value={fellowshipCompletion}
                            onChange={setFellowshipCompletion}
                          />
                        </>
                      )}

                      <IncomeSource
                        Active={edit}
                        value={incomeSource}
                        onChange={setIncomeSource}
                      />

                      {title !== 100000000 && (
                        <CustomTextField
                          Active={edit}
                          Title="Net Worth"
                          currency
                          value={netWorth}
                          onChange={setNetWorth}
                        />
                      )}
                    </Column>


                    <Column>
                      <CustomTextField
                        Active={edit}
                        Title="Job Title"
                        value={jobTitle}
                        onChange={setJobTitle}
                      />

                      {title === 100000000 && (
                        <>
                          <CustomTextField
                            Active={edit}
                            Title="Net Worth"
                            currency
                            value={netWorth}
                            onChange={setNetWorth}
                          />
                          <CustomTextField
                            Active={edit}
                            Title="Annual Income"
                            currency
                            value={annualIncome}
                            onChange={setAnnualIncome}
                          />
                        </>
                      )}
                    </Column>
                  </Grid>
                ) : (
                  // Mobile Layout
                  <Grid>

                    {title === 100000000 && (
                      <>
                        <TrainingPrograms
                          Active={edit}
                          value={residency}
                          Title="Residency Program"
                          type={591930000}
                          onChange={setResidency}
                        />
                        <CustomTextField
                          Active={edit}
                          Title="Residency Completion"
                          Type={"date"}
                          value={residencyCompletion}
                          onChange={setResidencyCompletion}
                        />

                        <TrainingPrograms
                          Active={edit}
                          value={fellowship}
                          Title="Fellowship Program"
                          type={591930001}
                          onChange={setFellowship}
                        />
                        <CustomTextField
                          Active={edit}
                          Title="Fellowship Completion"
                          Type={"date"}
                          value={fellowshipCompletion}
                          onChange={setFellowshipCompletion}
                        />
                      </>
                    )}

                    <CustomTextField
                      Active={edit}
                      Title="Job Title"
                      value={jobTitle}
                      onChange={setJobTitle}
                    />

                    <NonTrainingPrograms
                      Active={edit}
                      value={companyGroup}
                      valueName={companyGroupName}
                      Title="Company / Group"
                      onChange={setCompanyGroup}
                      textValue={companyGroupText}
                      onTextChange={setCompanyGroupText}
                      isCustom={isCustomCompanyGroup}
                      onCustomToggle={setIsCustomCompanyGroup}
                    />

                    <IncomeSource
                      Active={edit}
                      value={incomeSource}
                      onChange={setIncomeSource}
                    />

                    <CustomTextField
                      Active={edit}
                      Title="Annual Income"
                      currency
                      value={annualIncome}
                      onChange={setAnnualIncome}
                    />

                    <CustomTextField
                      Active={edit}
                      Title="Net Worth"
                      currency
                      value={netWorth}
                      onChange={setNetWorth}
                    />
                  </Grid>
                )}

              </Section>




              {/* ==================================================================== */}
              {/* ====================== CITIZENSHIP SECTION ======================== */}
              {/* ==================================================================== */}

              <Section>
                <TopRow>
                  <Title>Citizenship</Title>

                </TopRow>

                <Grid>
                  <CustomRadioButton
                    title="US Citizen"
                    Active={edit}
                    options={[true, false]}
                    value={isUSCitizen}
                    onChange={setIsUSCitizen}
                  />

                  {isUSCitizen ? (
                    <>
                      <CustomDropDown
                        Active={edit}
                        options={States}
                        Title="State of Birth"
                        value={usStateOfBirth}
                        onChange={setUsStateOfBirth}
                      />
                      <CustomTextField
                        Active={edit}
                        Title="Birthplace"
                        value={citNotes}
                        onChange={setCitNotes}
                      />
                    </>
                  ) : (
                    <CustomTextField
                      Active={edit}
                      Title="Birthplace"
                      value={citNotes}
                      onChange={setCitNotes}
                    />
                  )}

                  <CustomTextField
                    Active={edit}
                    Title="SSN *"
                    placeholder="xxx-xx-xxxx"
                    value={ssn}
                    onChange={handleSSN}
                  />
                </Grid>
              </Section>




              {/* ==================================================================== */}
              {/* =================== CONTACT INFORMATION =========================== */}
              {/* ==================================================================== */}

              <Section>
                <TopRow>
                  <Title>Contact Information</Title>

                </TopRow>

                <Grid>
                  <CustomTextField
                    Active={edit}
                    Title="Email"
                    value={email}
                    onChange={setEmail}
                  />
                  <CustomTextField
                    Active={edit}
                    Title="Mobile Phone *"
                    placeholder="xxx-xxx-xxxx"
                    value={mobilePhone}
                    onChange={handleMobilePhone}
                  />
                  <CustomTextField
                    Active={edit}
                    Title="Home Phone"
                    placeholder="xxx-xxx-xxxx"
                    value={homePhone}
                    onChange={handleHomePhone}
                  />

                  <CustomRadioButton
                    Active={edit}
                    title="Mobile Texting Opt-in"
                    options={[true, false]}
                    value={mobileTexting}
                    onChange={setMobileTexting}
                    message='Choose "No" to unsubscribe from text messaging'
                  />
                </Grid>
              </Section>




              {/* ==================================================================== */}
              {/* =========================== HOME ADDRESS =========================== */}
              {/* ==================================================================== */}

              <Section>
                <TopRow>
                  <Title>Home Address</Title>

                </TopRow>

                <Grid>
                  {type !== "Client" && <CustomRadioButton
                    Active={edit}
                    title="Same home address as main contact"
                    options={[true, false]}
                    value={sameHomeAddress}
                    onChange={setSameHomeAddress}
                  />
                  }
                  {!sameHomeAddress && (
                    <>
                      <CustomTextField
                        Active={edit}
                        Title="Street 1 *"
                        value={street1}
                        onChange={setStreet1}
                      />
                      <CustomTextField
                        Active={edit}
                        Title="Street 2"
                        value={street2}
                        onChange={setStreet2}
                      />
                      <CustomTextField
                        Active={edit}
                        Title="City *"
                        value={city}
                        onChange={setCity}
                      />
                      <CustomDropDown
                        Active={edit}
                        options={States}
                        Title="State *"
                        value={state}
                        onChange={setState}
                      />
                      <CustomTextField
                        Active={edit}
                        Title="ZIP Code *"
                        value={zip}
                        onChange={setZip}
                      />
                      <CustomTextField
                        Active={edit}
                        Title="Move-In Date"
                        value={moveInDate}
                        onChange={setMoveInDate}
                      />
                    </>
                  )}
                </Grid>
              </Section>




              {/* ==================================================================== */}
              {/* ========================== DRIVER LICENSE ========================= */}
              {/* ==================================================================== */}

              <Section>
                <TopRow>
                  <Title>Driver License</Title>

                </TopRow>

                <Grid>
                  <CustomTextField
                    Active={edit}
                    Title="License #"
                    value={dlNumber}
                    onChange={setDlNumber}
                  />
                  <CustomDropDown
                    Active={edit}
                    options={States}
                    Title="State"
                    value={dlState}
                    onChange={setDlState}
                  />
                  <CustomTextField
                    Active={edit}
                    Title="Issue Date"
                    Type="date"
                    value={dlIssue}
                    onChange={setDlIssue}
                  />
                  <CustomTextField
                    Active={edit}
                    Title="Expiration Date"
                    Type="date"
                    value={dlExpire}
                    onChange={setDlExpire}
                  />
                </Grid>
              </Section>



              {/* ==================================================================== */}
              {/* ========================= OTHER INFORMATION ======================= */}
              {/* ==================================================================== */}

              <Section>
                <TopRow>
                  <Title>Other Information</Title>

                </TopRow>

                <GridTwoColumns>
                  <Column>
                    <CustomTextField
                      Active={edit}
                      Title="Height"
                      value={height}
                      onChange={setHeight}
                    />
                    <CustomTextField
                      Active={edit}
                      Title="Weight"
                      value={weight}
                      onChange={setWeight}
                    />
                  </Column>

                  <Column>
                    <CustomTextArea
                      Active={edit}
                      Title="Current Medications / Conditions"
                      value={medications}
                      onChange={setMedications}
                    />
                  </Column>
                </GridTwoColumns>
              </Section>
            </>
            :
            <Section>
              <TopRow>
                <Title>Citizenship</Title>
              </TopRow>
              <Grid>
                <CustomTextField
                  Active={edit}
                  Title="SSN"
                  placeholder="xxx-xx-xxxx"
                  value={ssn}
                  onChange={handleSSN}
                />
                {screenWidth >= 690 && (
                  <>
                    <div></div>
                    <div></div>
                  </>
                )
                }
              </Grid>
            </Section>

          }

          {edit && type === "Client" && <>
            <ButtonContainer >
              <SaveorSpouseButton onClick={handleSaveContinueToHousehold}>Save & Continue to Update Spouse/Children</SaveorSpouseButton>
              <SaveorSpouseButton className="Desktop-Btn" background='#ecf3fb' color="#304961" boxshadow='0px 0px 0px' onClick={handleUpdate}>Save & Stay on This Page</SaveorSpouseButton>

            </ButtonContainer>
          </>
          }
          {!edit && type === "Client" && <>
            <ButtonContainer >
              <SaveorSpouseButton className="Desktop-Btn" background='#ecf3fb' color="#304961" boxshadow='0px 0px 0px' onClick={handleContinueToHousehold}>Navigate to Spouse/Children</SaveorSpouseButton>

            </ButtonContainer>
          </>
          }
          {edit && type !== "Client" && !createContact && <>
            <ButtonContainer >
              <SaveorSpouseButton onClick={handleUpdate}>Submit</SaveorSpouseButton>
              <SaveorSpouseButton className="Desktop-Btn" background='#ecf3fb' color="#304961" boxshadow='0px 0px 0px' onClick={handleCancel}>Cancel</SaveorSpouseButton>

            </ButtonContainer>
          </>}
          {!edit && type !== "Client" && !createContact && <>
            <ButtonContainer >
              <SaveorSpouseButton className="Desktop-Btn" background='#ecf3fb' color="#304961" boxshadow='0px 0px 0px' onClick={handleCancel}>Cancel</SaveorSpouseButton>

            </ButtonContainer>
          </>
          }
          {edit && type !== "Client" && createContact && <>
            <ButtonContainer >
              <SaveorSpouseButton onClick={handleCreate}>Submit</SaveorSpouseButton>
              <SaveorSpouseButton className="Desktop-Btn" background='#ecf3fb' color="#304961" boxshadow='0px 0px 0px' onClick={handleCancel}>Cancel</SaveorSpouseButton>

            </ButtonContainer>
          </>
          }


        </PageInfo>
        {!edit && type === "Client" && <>
          <SaveorSpouseButton className="Mobile-Btn" background='white' color="#304961" boxshadow='0px 0px 0px' onClick={handleContinueToHousehold}>Navigate to Spouse/Children</SaveorSpouseButton>
        </>
        }
        {edit && type === "Client" && <>
          <SaveorSpouseButton className="Mobile-Btn" background='white' color="#304961" boxshadow='0px 0px 0px' onClick={handleUpdate}>Save & Stay on This Page</SaveorSpouseButton>
        </>
        }
        {type !== "Client" && !createContact && <>
          <SaveorSpouseButton className="Mobile-Btn" background='white' color="#304961" boxshadow='0px 0px 0px' onClick={handleCancel}>Cancel</SaveorSpouseButton>

        </>
        }
        {edit && type !== "Client" && createContact && <>
          <SaveorSpouseButton className="Mobile-Btn" background='white' color="#304961" boxshadow='0px 0px 0px' onClick={handleCancel}>Cancel</SaveorSpouseButton>

        </>
        }
      </Wrapper>
    </>
  );

}



// ======================================================================
// ============================== STYLES ================================
// ======================================================================

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: 100%;
`;
const WelcomeMessage = styled.div`
  background-color: #ffffff;
  border: 1px solid #e0e7f0;
  border-left: 4px solid var(--darkBlue);
  padding: 25px;
  margin-bottom: 30px;
  border-radius: 8px;
  color: #304961;
  font-family: "Museo Sans Cyrl";
  font-size: 16px;
  line-height: 1.6;
  white-space: pre-line;
  max-width: 100%;
  box-shadow: 0 2px 4px rgba(48, 73, 97, 0.05);
`;

const ErrorMessage = styled.div`
  color: #b20000;
  font-family: "Museo Sans Cyrl";
  font-size: 16px;
  line-height: 1.6;
  background-color: #fff5f5;
  border: 1px solid #f3d6d6;
  border-left: 4px solid #b20000;
  padding: 16px 18px;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(178, 0, 0, 0.05);
`;

const Message = styled.div`
  color: #304961;
  font-family: "Museo Sans Cyrl";
  font-size: 16px;
  line-height: 1.6;
  background-color:rgb(252, 254, 255);
  border: 1px solid rgb(214, 231, 243);
  border-left: 4px solid #304961;
  padding: 16px 18px;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(48, 73, 97, 0.05);
`;
const PageInfo = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: start;
  gap: 5vh;
  flex: 1;
  background-color: #ecf3fb;
  border-radius: 20px;
padding: 30px 35px 0 35px;

  @media screen and (max-width: 690px) {
    padding: 15px 15px 0 15px;

  }
`;

const Section = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: 100%;
`;

const TopRow = styled.div`
  display: flex;
  align-items: space-between;
  justify-content:space-between;
  gap:10px;
`;

const Title = styled.div`
  color: #304961;
  font-family: "Museo Sans Cyrl";
  font-size: 20px;
  font-weight: 400;
  white-space:nowrap;

`;

const EditButton = styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;
  color: #87a9bf;
  font-size: 20px;
    font-weight: 400;
white-space:nowrap;
  font-style: italic;
  text-decoration: underline;
  &:hover {
color:#304961
;
}

    @media screen and (max-width: 690px) {
  font-size: 15px;
    font-weight: 400;

  }
`;
const ButtonContainer = styled.div`
  display: flex;
  background-color:inherit;
align-items:flex-end;
justify-content:flex-end;
gap:10px;
padding:0 3% 0 3%;
  color: #304961;
  width: calc(100% + 70px); 
  margin: 0 -35px;

height:9vh;
  border-radius: 0 0 20px 20px;


      @media screen and (max-width: 690px) {
  width: calc(100% + 30px); 
    margin: 0 -15px;
    display: flex;
    flex-direction: column;
    align-items:center;
padding:0 0% 0 0%;

  }
`;

const SaveorSpouseButton = styled.button`
display:flex;
  box-shadow:${({ boxshadow }) => boxshadow || "0px 0px 20px #304961"};
background-color: ${({ background }) => background || "#304961"};
border:none;
justify-content:center;
align-items:center;
border-radius:70px;
padding:1%;
margin:3% 0 3% 0;
  border:  solid 1px  #304961;
  min-width:10%;
    cursor: pointer;
       &.Mobile-Btn {
      display: none;
    }
  color:${({ color }) => color || "#E1E7EB"};
    font-size: 1rem; 
  height:60%;
  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
    color: #a0a0a0;
  }

  &:hover:not(:disabled) {
    text-shadow: 0 0 10px rgba(225, 231, 235, 0.8),
                 0 0 20px rgba(225, 231, 235, 0.6),
                 0 0 30px rgba(225, 231, 235, 0.4);
  }
&:hover {
color:white;
  text-shadow: 0 0 10px rgba(225, 231, 235, 0.8),
               0 0 20px rgba(225, 231, 235, 0.6),
               0 0 30px rgba(225, 231, 235, 0.4);
}
          @media screen and (max-width: 690px) {
    font-size: 0.9rem; 
  padding:2%;
  width:100%;
  margin:0 0 0 0;
  height:5vh;
       &.Desktop-Btn {
      display: none;
    }
             &.Mobile-Btn {
      display: block;

    }
  }
`;
// const VerticalSeperator = styled.div`
//   background-color: white;
//   width:1px;
//   height:100%;
// `;

const SaveButton = styled.div`
  background: #304961;
  color: white;
  padding: 6px 12px;
  border-radius: 300px;
  font-size: 12px;
  cursor: pointer;
  text-transform: uppercase;
    @media screen and (max-width: 690px) {padding:2%;}
`;

const Grid = styled.div`
  display: grid;
  gap: 30px;
  width: 100%;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
`;

const GridTwoColumns = styled.div`
  display: grid;
  gap: 30px;
  grid-template-columns: 1fr 2fr;

  @media (max-width: 684px) {
    grid-template-columns: 1fr;
  }
`;

const Column = styled.div`

  display: flex;
  flex-direction: column;
  gap: 8px;
`;



export default MemberInformation;
